let mediaWithText = document.querySelectorAll('.media-with-text:not(.media-with-text--reverse-large)');

if (mediaWithText.length > 0) {
mediaWithText.forEach((mediawithTextEl) => {

let sideText = mediawithTextEl.querySelectorAll('.media-side--text-container');
  
  sideText.forEach((element) => {
    // get height
    let width = element.querySelector('.media-side--text').offsetWidth;
    // set top position
    console.log(width);
    
    element.style.bottom = `calc(${width}px - 1.5rem)`;
  });

});
}